import { useState, useEffect } from "react";
import styles from "./addmaintenanceform.module.css";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { toast } from "react-smart-toaster";
import { Plus, UploadCloud, X } from "react-feather";
import { Button, FormControl, InputLabel, MenuItem, ListSubheader, Select, TextField, Autocomplete, createFilterOptions, FormControlLabel, Checkbox } from "@mui/material";
import { AddLogCallAPI } from "../../../components/AddLogs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const schema = yup.object().shape({
  tenant_id: yup.string().required("This field is Required"),
  category: yup.string().required("This field is Required"),
  description: yup.string().required("This field is Required").max(200, "Description cannot be more than 200 characters"),
  priority: yup.string().required("This field is Required"),
  terms: yup.boolean().when("category", (category) => {
    if (category && category === "Mount Television")
      return yup.boolean().oneOf([true], "Please accept terms to proceed.");
    else
      return yup.boolean();
  }),
  time_terms1: yup.boolean(),
  time_terms2: yup.boolean(),
  schedule_time: yup.string().when("time_terms2", {
    is: true,
    then: (schema) => schema.required("This field is Required"),
    otherwise: (schema) => schema.notRequired(),
  }),
}).test(
  "one-checkbox-required",
  "Please select at least one option",
  function (values) {
    if (!values.time_terms1 && !values.time_terms2) {
      return this.createError({
        path: "time_terms_error",
        message: "Please select at least one option",
      });
    }
    return true;
  }
);

const categoryGroupOptions = [
  { label: "Electrical", parent: 1 },
  { value: "Mount Television", label: "Mount Television", parent: 0, category: "Electrical", img_path: "/static/img/tv.svg" },
  { value: "Electrical Socket", label: "Electrical Socket", parent: 0, category: "Electrical", img_path: "/static/img/ElectricalSocket.svg" },
  { value: "Light Switch/Dimmer", label: "Light Switch/Dimmer", parent: 0, category: "Electrical", img_path: "/static/img/Dimmer.svg" },
  { label: "Plumbing", parent: 1 },
  { value: "Leak", label: "Leak", parent: 0, category: "Plumbing", img_path: "/static/img/Leak.svg" },
  { value: "Drain Clogged", label: "Drain Clogged", parent: 0, category: "Plumbing", img_path: "/static/img/DrainClogged.svg" },
  { value: "Water Temperature Issue", label: "Water Temperature Issue", parent: 0, category: "Plumbing", img_path: "/static/img/WaterTemperature.svg" },
  { value: "Heating & Cooling System", label: "Heating & Cooling System", parent: 0, category: "Plumbing", img_path: "/static/img/heat&cool.svg" },
  { label: "Appliances", parent: 1 },
  { value: "Stove/Oven Issue", label: "Stove/Oven Issue", parent: 0, category: "Appliances", img_path: "/static/img/StoveOven.svg" },
  { value: "Refrigerator Issue", label: "Refrigerator Issue", parent: 0, category: "Appliances", img_path: "/static/img/Refrigerator.svg" },
  { value: "Washer/Dryer Issue", label: "Washer/Dryer Issue", parent: 0, category: "Appliances", img_path: "/static/img/Washer.svg" },
  { label: "Smart Devices", parent: 1 },
  { value: "Door Lock", label: "Door Lock", parent: 0, category: "Smart Devices", img_path: "/static/img/Door.svg" },
  { value: "Dimmer", label: "Dimmer", parent: 0, category: "Smart Devices", img_path: "/static/img/bulb.svg" },
  { value: "Thermostat", label: "Thermostat", parent: 0, category: "Smart Devices", img_path: "/static/img/temperature.svg" },
  { label: "Other", parent: 1 },
  { value: "Other Issue", label: "Other Issue", parent: 0, category: "Other", img_path: "/static/img/other.svg" },
];

const AddMaintenanceForm = ({ setAddModalOpen, setLoading, setSnackbarOpen, setSnackbarMsg, onSubmitLocal, tenant_id }) => {
  const { getAccessTokenSilently } = useAuth0();
  const [tenantList, setTenantList] = useState([]);
  const [tenantList2, setTenantList2] = useState([]);
  const [charsLeft, setCharsLeft] = useState(200);
  const [ImgPathTemp, setImgPathTemp] = useState({ Files: [], imagePathArr: [] });
  const [isMountTVCat, setIsMountTVCat] = useState(false);
  const [isTimeTerms, setIsTimeTerms] = useState(false);

  const { handleSubmit, control, errors, setValue, clearErrors } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    defaultValues: {
      terms: false,
      time_terms1: false,
      time_terms2: false,
      tenant_id: ""
    }
  });

  useEffect(() => {
    async function fetchTenants() {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
      await axios.get(process.env.REACT_APP_CASE_API_URL + "v1/property-tenant-list", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then((response) => {
        let tFinalList = [];
        let tFinalList2 = [];

        let templistNew = response.data.data;
        if (tenant_id) {
          templistNew = response.data.data?.map(item => {
            let opts = item?.options?.filter(i => i?.value === parseInt(tenant_id));
            return { ...item, options: opts };
          });
          templistNew = templistNew.filter(i => i.options?.length > 0);

          setValue('tenant_id', tenant_id);
        }

        templistNew?.map((item) => {
          tFinalList.push({ label: item.label, parent: 1 });
          item?.options?.map((subItem) => {
            tFinalList.push({
              value: subItem.value,
              label: subItem.label,
              parent: 0,
              propertyId: item?.id,
            });
            return false;
          });

          return false;
        });

        templistNew?.map((item) => {
          item?.options?.map((subItem) => {
            tFinalList2.push({
              group: item?.label,
              value: subItem?.value,
              label: subItem.label
            });
            return false;
          });

          return false;
        });

        setTenantList(tFinalList);
        setTenantList2(tFinalList2);
      }).catch((error) => {
        if (typeof error.response !== "undefined")
          toast.error(error.response.data.message);
      });
    }

    fetchTenants();
  }, [getAccessTokenSilently, tenant_id]);

  const onSubmit = async (data) => {
    setAddModalOpen(false);

    let postData = {};

    postData = { ...postData, tenant_id: data?.tenant_id, priority: data?.priority, description: data?.description };
    if (data?.tenant_id) {
      let selectTenant = tenantList?.filter((i) => i?.value === parseInt(data?.tenant_id));
      postData = { ...postData, property_id: selectTenant[0]?.propertyId };
    }
    if (data?.category) {
      let selectCat = categoryGroupOptions?.filter((i) => i?.value === data.category);
      postData = { ...postData, category: selectCat[0]?.category, sub_category: data?.category };
    }

    if (data?.time_terms2) {
      postData = { ...postData, is_tenant_timeslot: 1, schedule_time: data?.schedule_time };
    }

    let formData = new FormData();
    Object.keys(postData).map((key) => {
      formData.append(key, postData[key]);
      return true;
    });
    if (ImgPathTemp.Files.length) {
      for (let n in ImgPathTemp.Files) {
        formData.append("uploadImages[]", ImgPathTemp.Files[n]);
      }
    }

    setLoading(true);

    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    return axios.post(process.env.REACT_APP_CASE_API_URL + "v1/maintenance-requests", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    }).then((response) => {
      setLoading(false);

      setSnackbarOpen(true);
      setSnackbarMsg(response.data.message);

      onSubmitLocal(response.data.data);

      let logData = {
        title: "New maintenance request has been created",
        description: [
          "Name: " + response.data.data.title,
          "Request number: " + response.data.data.request_no,
          "Apt No: " + response.data.data.property_name + " - " + response.data.data.apt_name,
          "Tenant: " + response.data.data.tenant_name,
        ],
      };
      AddLogCallAPI(logData, token);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  const fileHandler = (e) => {
    var validExtensions = ["jpg", "jpeg", "png", "svg"]; //array of valid extensions
    var fileName = e.target.files[0].name;
    var fileNameExt = fileName.substr(fileName.lastIndexOf(".") + 1);
    if (validExtensions.indexOf(fileNameExt.toLowerCase()) === -1) {
      toast.error("File type is not allowed");
    } else if (e.target.files[0].size > 5242880) {
      toast.error("Image size should not be greater than 5 mb.");
    } else {
      let tempFiles = ImgPathTemp.Files;
      let tempImages = ImgPathTemp.imagePathArr;
      let newData = ImgPathTemp;
      for (let n = 0; n < e.target.files.length; n++) {
        let file = e.target.files[n];
        tempImages.push(URL.createObjectURL(file));
        tempFiles.push(file);
      }
      newData = { ...newData, imagePathArr: tempImages, Files: tempFiles };
      setImgPathTemp(newData);
    }
  }

  const deleteTempImage = (index) => {
    let tempFiles = ImgPathTemp.Files;
    let tempImages = ImgPathTemp.imagePathArr;
    let newData = ImgPathTemp;

    tempFiles = tempFiles.filter(function (item, i) {
      return i !== index;
    });

    tempImages = tempImages.filter(function (item, i) {
      return i !== index;
    });

    newData = { ...newData, imagePathArr: tempImages, Files: tempFiles };
    setImgPathTemp(newData);
  }

  const filterOptions = createFilterOptions({
    matchFrom: "any"
  });

  return (<div className={`${styles.ModalFormGroup}`}>
    <form onSubmit={handleSubmit(onSubmit)}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <div className={`${styles.ReqAddRow}`}>
          <div className={`${styles.ReqAddFormSec}`}>
            <div className={`${styles.FormSec}`}>
              <div className={`${styles.FormGroupFull} FormGroup`}>
                {/* <label className={`${styles.FilterLabel}`}>Tenant Selection</label> */}
                <FormControl fullWidth>
                  <Controller
                    name="tenant_id"
                    control={control}
                    render={(field) => (<Autocomplete
                      value={field?.value ? tenantList?.filter(i => i?.value === field?.value)[0] : null}
                      filterOptions={filterOptions}
                      options={tenantList2.sort((a, b) => -b.group.localeCompare(a.group))}
                      groupBy={(option) => option.group}
                      getOptionLabel={(option) => option.label}
                      renderInput={(params) => (<TextField {...params} label="Select Tenant*" />)}
                      onChange={(event, newValue) => {
                        setValue('tenant_id', newValue?.value);
                        clearErrors();
                      }}
                    />)}
                  />
                </FormControl>
                {errors.tenant_id && (<p className={`${styles.ErrorM}`}>{errors.tenant_id.message}</p>)}
              </div>
            </div>
            <div className={`${styles.FormSec}`}>
              <div className={`${styles.FormGroupFull} FormGroup`}>
                {/* <label className={`${styles.FilterLabel}`}>Category Selection</label> */}
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Select Category*</InputLabel>
                  <Controller
                    name="category"
                    control={control}
                    render={(field) => (
                      <Select
                        label="Select Category*"
                        {...field}
                        onChange={(e) => {
                          field.onChange(e);
                          if (e.target.value === 'Mount Television') {
                            setIsMountTVCat(true);
                          } else {
                            setIsMountTVCat(false);
                          }
                        }}
                      >
                        {categoryGroupOptions.map((item) => {
                          if (item?.parent === 1)
                            return (<ListSubheader className={`${styles.GropSelectTitle}`}>{item?.label}</ListSubheader>);
                          else
                            return (<MenuItem value={item?.value} className={`${styles.GropSelectList}`}>
                              <img src={item?.img_path} alt="" />
                              {item?.label}
                            </MenuItem>);
                        })}
                      </Select>
                    )}
                  />
                </FormControl>
                {errors.category && (<p className={`${styles.ErrorM}`}>{errors.category.message}</p>)}
              </div>
            </div>
            <div className={`${styles.FormSec}`}>
              <div className={`${styles.FormGroupFull} FormGroup`}>
                {/* <label className={`${styles.FilterLabel}`}>Describe the Maintenance Issue</label> */}
                <Controller
                  name={`description`}
                  control={control}
                  render={(field) => (
                    <TextField
                      {...field}
                      onChange={(e) => {
                        field.onChange(e);
                        setCharsLeft(200 - e.target.value.length);
                      }}
                      id="outlined-multiline-static"
                      label="Add Description*"
                      variant="outlined"
                      inputProps={{ maxLength: 200 }}
                      multiline
                      rows={6}
                    />
                  )}
                />
                <p className={`${styles.RemainingText}`}>{charsLeft} {charsLeft > 1 ? "characters" : "character"} remaining</p>
                {errors.description && (<p className={`${styles.ErrorM}`}>{errors?.description?.message}</p>)}
              </div>
            </div>
            <div className={`${styles.FormSec}`}>
              <div className={`${styles.FormGroupFull} FormGroup`}>
                {/* <label className={`${styles.FilterLabel}`}>Priority Level</label> */}
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Select Priority*</InputLabel>
                  <Controller
                    name="priority"
                    control={control}
                    render={(field) => (
                      <Select
                        label="Select Priority*"
                        {...field}
                        onChange={(e) => {
                          field.onChange(e);
                        }}
                      >
                        <MenuItem value={1}>Low</MenuItem>
                        <MenuItem value={2}>Medium</MenuItem>
                        <MenuItem value={3}>High</MenuItem>
                      </Select>
                    )}
                  />
                </FormControl>
                {errors.priority && (<p className={`${styles.ErrorM}`}>{errors.priority.message}</p>)}
              </div>
            </div>
            <div className={`${styles.FormIMGSec} ${styles.FileUploadSmall}`}>
              <div className={`${styles.FileIMGDiv}`}>
                {ImgPathTemp.imagePathArr.length === 0 && (<label className={`${styles.TakePhoteBU}`} for="file-upload"><UploadCloud /> Upload Photo</label>)}
                {ImgPathTemp.imagePathArr.length === 0 && (<p className={`${styles.UploadTextNew}`}>File size upto 5 MB. JPEG, JPG, PNG only</p>)}
                <div className={`${styles.FileUpDuBUDiv}`}>
                  <input id="file-upload" type="file" onChange={fileHandler} accept=".jpg,.png,.jpeg,.svg" inputProps={{ accept: "image/*" }} />
                </div>
                <div className={`${styles.UpIMGSec}`}>
                  {ImgPathTemp.imagePathArr.map((item, index) => {
                    return (<div className={`${styles.ImgFile}`}>
                      <img src={item} alt="" />
                      <Button onClick={deleteTempImage.bind(this, index)}>
                        <X />
                      </Button>
                    </div>);
                  })}
                  {ImgPathTemp.imagePathArr.length > 0 && (<label className={`${styles.TakePhoteSQRBU}`} for="file-upload"><Plus /></label>)}
                </div>
              </div>
            </div>
            {isMountTVCat && <>
              <div className={`${styles.DisclaimerText}`}>
                <p><span>TV Mount Waiver Agreement</span><br />We recommend that the tenant be present in their unit during the TV mounting appointment to ensure the installation proceeds smoothly. Please be advised that the property management team and its contractors are <span>not liable for any damage to the TV or related equipment during or after installation.</span></p>
                <p>If adjustments or re-mounting are requested after the initial installation, a <span>$100 service fee</span> will apply. <br />By submitting this maintenance request, you acknowledge and agree to the terms of this waiver.</p>
                <p>Additionally, if the appointment cannot be completed for any reason such as missing parts, incorrect mounting instructions, or other issues that prevent installation, a <span>$100 service fee</span> will be required to reschedule the appointment.</p>
                <p>By submitting this maintenance request, you acknowledge that you have read and agree to these terms.</p>
                <FormControlLabel className="FormCheckbox"
                  control={<Controller
                    name="terms"
                    control={control}
                    render={(props) => <Checkbox
                      /*{...props}
                      onChange={(e) => {
                        //props.onChange(e);
                        setValue('terms', e.target.checked);
                      }}
                      checked={props?.value ? true : false}*/
                      checked={props.value}
                      onChange={(e) => props.onChange(e.target.checked)}
                    />}
                  />}
                  label="I have read and agree to the terms of the TV Mount Waiver Agreement."
                />
                {errors.terms && (<p className={`${styles.ErrorM}`}>{errors.terms.message}</p>)}
              </div>
            </>}
            <div className={`${styles.DisclaimerText} ${styles.Blue}`}>
              <p>By submitting this request, you confirm that the information provided is accurate to the best of your knowledge. </p>
              <p><span>Service availability, estimated time, and charges may vary based on the issue</span>. Any additional work or cost will be communicated before proceeding.</p>
              <FormControlLabel className="FormCheckbox"
                control={<Controller
                  name="time_terms1"
                  control={control}
                  render={(props) => <Checkbox
                    /*{...props}
                    onChange={(e) => {
                      //props.onChange(e);
                      setValue('terms', e.target.checked);
                    }}
                    checked={props?.value ? true : false}*/
                    checked={props.value}
                    onChange={(e) => {
                      props.onChange(e.target.checked);
                      setValue('time_terms2', false);
                      setIsTimeTerms(false);
                    }}
                  />}
                />}
                label="You authorize our service team to enter your apartment and carry out the request repair"
              />
              <FormControlLabel className="FormCheckbox"
                control={<Controller
                  name="time_terms2"
                  control={control}
                  render={(props) => <Checkbox
                    checked={props.value}
                    onChange={(e) => {
                      props.onChange(e.target.checked);
                      setValue('time_terms1', false);
                      setIsTimeTerms(e.target.checked);
                    }}
                  />}
                />}
                label="I would like to be present at home during the maintenance call. I will available during the following  time slot."
              />
              {errors?.time_terms_error && (<p className={`${styles.ErrorM}`}>{errors?.time_terms_error?.message}</p>)}
              {isTimeTerms && <>
                <div className={`${styles.FormGroupFull} FormGroup`}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Select Time*</InputLabel>
                    <Controller
                      name="schedule_time"
                      control={control}
                      render={(field) => (
                        <Select
                          label="Select Time*"
                          {...field}
                          onChange={(e) => {
                            field.onChange(e);
                          }}
                        >
                          <MenuItem value={"Morning (9AM - 12PM)"}>Morning (9AM - 12PM)</MenuItem>
                          <MenuItem value={"Afternoon (12PM - 3PM)"}>Afternoon (12PM - 3PM)</MenuItem>
                          <MenuItem value={"Evening (3PM - 6PM)"}>Evening (3PM - 6PM)</MenuItem>
                        </Select>
                      )}
                    />
                  </FormControl>
                  {errors.schedule_time && (<p className={`${styles.ErrorM}`}>{errors.schedule_time.message}</p>)}
                </div>
              </>}
            </div>
          </div>
        </div>
      </LocalizationProvider>
      <div className={`${styles.ButtonAction}`}>
        <Button className="CancelPopupBU" type="button" onClick={(e) => setAddModalOpen(false)}>Cancel</Button>
        <Button className="SubmitPopupBU" type="submit">Add</Button>
      </div>
    </form>
  </div>);
};

export default AddMaintenanceForm;